import { BaseDeliveryDatesClient, ISODate } from "@core/types";
import { supabaseClient } from "../supabase";
import { Tables } from "../types/supabase";
import { convertSupaDeliveryInterval } from "./converters";

class DeliveryDatesClient extends BaseDeliveryDatesClient {
  async getDeliveryDates() {
    const { data, error } = await supabaseClient.functions.invoke<ISODate[]>("delivery-dates");

    if (error) throw new Error(error.message);

    return data as ISODate[];
  }

  async getDeliveryIntervals(_shippingMethodId: string, date: ISODate) {
    const { data: deliveryIntervals, error } = await supabaseClient.functions.invoke<Tables<"delivery_intervals">[]>(
      "delivery-intervals",
      {
        body: { isoDate: date },
      }
    );

    if (error) throw new Error(error.message);

    return !!deliveryIntervals?.length ? deliveryIntervals?.map(convertSupaDeliveryInterval) : [];
  }
}

export default DeliveryDatesClient;
